import React from 'react';
import I18n from 'i18n-js';
import { shuffle } from 'lodash';
import ListingsCollection from '@reverbdotcom/commons/src/components/listings_collection';
import { ChildProps } from 'react-apollo';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { withMpid, MpidProps } from  '@reverbdotcom/commons/src/with_mpid';


import {
  loggedOutRowQuery,
  LoggedOutRecommendations,
} from './recommended_listings_common';

interface ExternalProps {
  limit?: number;
  minCount?: number;
}

export type IProps = ExternalProps & MpidProps;


export function LoggedOutRecommendedListingsRow(props: ChildProps<IProps, LoggedOutRecommendations.Query>) {
  const minCount = props.minCount || 1;
  let listings = props.data?.loggedOutRecommendations?.listings || [];
  const limit = props.limit || 12;

  if ( props.data?.loading || listings.length < minCount) {
    return null;
  }
    
  listings = shuffle(listings).slice(0, limit);
  
  return (
    <div className="homepage-container__component-wrapper">
      <ListingsCollection
        listings={listings}
        title={I18n.t('discovery.recommendedListings.loggedOutTitle')}
      />
    </div> 
  );
}

const connect = withGraphql<IProps>(
  loggedOutRowQuery,
  {
    options: (props) => {
      return {
        ssr: false,
        variables: {
          mpid:props.mpid,
        },
      };
    },
    skip: (props) => !props.mpid,
  },
);


export default withMpid<IProps>((connect(LoggedOutRecommendedListingsRow)));
